import { connect } from 'react-redux';
import { getScreenData } from 'cw-ui-core';
import ConditionsList from './ConditionsList';

const mapStateToProps = (state, props) => {
    const data = getScreenData(state.screen, props.path, props.screenKey);
    if (data == null) {
        return {};
    }
    return {
        conditions:
            data
                ?.get('conditions')
                ?.toArray()
                ?.map(a => a.toObject()) ?? [],
        args: data.get('arguments'),
    };
};

const ConditionsListContainer = connect(mapStateToProps)(ConditionsList);

export default ConditionsListContainer;
